import { render } from "./VUEAppContentGestioneUtenti.vue?vue&type=template&id=3174e791"
import script from "./VUEAppContentGestioneUtenti.vue?vue&type=script&lang=js"
export * from "./VUEAppContentGestioneUtenti.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__